import { useSettings } from '@wu/widget-core';
import { layoutsMap } from './layouts';

export const Files = () => {
  const { layout } = useSettings();

  const FilesComponent = layoutsMap[layout];

  return <FilesComponent />;
};
